export default "/images/1b1b0c474b3e63a92643d88380a783a6.avif";